import { Component } from '@theme/component';
import { scrollTo } from '@theme/scroll-container';

/**
 * Zerbay "Back to top" control (LOCD-07, PAGE-13). The button inside calls scrollToTop() through `on:click="/scrollToTop"`.
 * Horizon scrolls `.page-wrapper` at 990px and up, so the scroll goes through @theme/scroll-container, not window.scrollTo.
 */
class ZerbayBackToTop extends Component {
  scrollToTop() {
    scrollTo({ top: 0, behavior: 'smooth' });
  }
}

if (!customElements.get('zerbay-back-to-top')) {
  customElements.define('zerbay-back-to-top', ZerbayBackToTop);
}
